import styled from 'styled-components';
import type { BuilderBlockProps } from './Builder';
import { useBanner } from './bannerProvider';
import { getSideMediaBlocks } from './utils';

type MediaLayoutBuilderProps = {
  children(blocks: BuilderBlockProps['blocks']): React.JSX.Element;
  blocks: BuilderBlockProps['blocks'];
  components: NonNullable<BuilderBlockProps['components']>;
  isColumn: boolean;
  mobileView?: BuilderBlockProps['mobileView'];
  adaptiveMedia?: BuilderBlockProps['adaptiveMedia'];
  getMediaHeightSetter?: BuilderBlockProps['getMediaHeightSetter'];
};

export function MediaLayoutWrapper({
  children,
  blocks,
  components,
  isColumn,
  mobileView,
  adaptiveMedia,
  getMediaHeightSetter
}: MediaLayoutBuilderProps) {
  const { hasBannerBlocks } = useBanner();

  const { leftMediaBlocks, rightMediaBlocks, blocksWithoutMedia } =
    getSideMediaBlocks({ blocks });

  const hasMediaBlocks =
    leftMediaBlocks.length !== 0 || rightMediaBlocks.length !== 0;

  if (!hasMediaBlocks || mobileView || !isColumn) {
    return children(blocks);
  }

  return (
    <Container _hasBannerBlocks={hasBannerBlocks}>
      {leftMediaBlocks.length !== 0 &&
        leftMediaBlocks.map((mediaBlock) => {
          const MediaComponent = components[mediaBlock.type];

          return (
            <MediaComponent
              key={mediaBlock.id}
              {...mediaBlock}
              adaptiveMedia={adaptiveMedia}
              setMediaHeight={getMediaHeightSetter?.(mediaBlock.id)}
            />
          );
        })}

      {children(blocksWithoutMedia)}

      {rightMediaBlocks.length !== 0 &&
        rightMediaBlocks.map((mediaBlock) => {
          const MediaComponent = components[mediaBlock.type];

          return (
            <MediaComponent
              key={mediaBlock.id}
              {...mediaBlock}
              adaptiveMedia={adaptiveMedia}
              setMediaHeight={getMediaHeightSetter?.(mediaBlock.id)}
            />
          );
        })}
    </Container>
  );
}

const Container = styled.div<{
  _hasBannerBlocks: boolean;
}>`
  width: 100%;
  height: 100%;
  display: flex;
  ${({ _hasBannerBlocks }) => !_hasBannerBlocks && 'align-items: center;'};
`;
